import {Map, List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import Session from 'web-app/react/entities/sessions/model';
import Product from 'web-app/react/entities/products/model';

export const fetchPlansByChildIds = childIds => {
    return RESTClient.postAuthenticatedObservable('v2/plans/list', {
        childIds,
    }).map(response => ({
        plans: Map(response.plans.map(plan => [plan.id, plan])),
        sessions: List(response.sessions).map(Session.fromAPI),
        products: List(response.products).map(Product.fromAPI),
    }));
};
